import { TranslationKeys } from './locales';

export const ja: TranslationKeys = {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    close: '閉じる',
    save: '保存',
    delete: '削除',
    edit: '編集',
    search: '検索',
    loading: '読み込み中',
    noData: 'データが見つかりません',
    yes: 'はい',
    no: 'いいえ',
    all: '全て',
    yearUnit: '年',
    register: '登録',
    casesUnit: '件',
  },
  
  login: {
    title: 'ログイン',
    id: 'ユーザーID',
    password: 'パスワード',
    loginButton: 'ログイン',
    findId: 'ID検索',
    findPassword: 'パスワード検索',
    idPlaceholder: 'ユーザーIDを入力してください。',
    passwordPlaceholder: 'パスワードを入力してください。',
    keepLoggedIn: 'ログイン状態を維持',
    invalidCredentials: 'アカウント情報が無効です。 <br /> ユーザーIDとパスワードを確認してください！',
  },
  
  dashboard: {
    title: 'ダッシュボード',
    farmMachineryCount: '地図上の農機',
    totalMachinery: '合計',
    unit: '台',
    runningMachinery: '運行中',
    stoppedMachinery: '停止',
    map: '地図',
    list: 'リスト',
  },
  
  control: {
    title: '農機事故制御',
    farmMachineryOnMap: '地図上の農機',
    searchPlace: '場所または住所を入力',
    placeAddress: '場所/住所',
    normal: '通常',
    cadastral: '地籍図',
    satellite: '衛星',
    eventDate: 'イベント日時',
    deviceName: 'デバイス名',
    owner: '所有者',
    status: 'ステータス',
    running: '運行中',
    stopped: '停止',
    noData: 'データが見つかりません',
    realtimeDetectionHistory: 'リアルタイム検出履歴',
    farmMachineryList: '農機リスト',
    searchedFarmMachinery: '検索された農機',
    resultsPerPage: 'ページあたりの検索結果数',
    realtimeOperationStatus: 'リアルタイム運行情報',
    danger: '危険',
    caution: '注意',
    operating: '運行中',
    notOperating: '未運行',
    rolloverAccident: '転倒事故',
    searchDeviceOwner: 'デバイス名または所有者名で検索',
    lastOperation: '最終運行',
    dangerAccident: '危険(転倒事故)',
    deviceList: 'デバイスリスト',
    noDeviceFound: 'デバイスが見つかりません',
    selectDetectionType: '検出種類選択',
    selectDeviceType: 'デバイス種類選択',
    totalFarmMachinery: '全農機',
    checkDate: '日付をご確認ください。',
    selectBothDates: '開始日と終了日の両方を選択してください。',
    group: 'グループ',
    noRecord: '運行記録なし',
    operationRecord: '運行記録',
    user: 'ユーザー',
    unlockRolloverStatus: '車両転倒状態を解除しますか？',
    unlockRolloverContent: '解除すると、事故検出状態が正常に処理されます。\n正常処理後はキャンセルできません。',
    confirmUnlock: 'はい、解除します',
    openContact: '連絡先を閲覧しますか？',
    protectingPrivacy: '賃借人の個人情報を保護しています。',
    openLesseeContact: '賃借人の連絡先を閲覧しますか？',
    openContactButton: '連絡先を閲覧する',
    protectDevicePrivacy: (item: string) => `デバイス ${item} の個人情報保護のため`,
    enterOfficerName: '閲覧する担当者の正確な氏名を入力してください。',
    accidentDetected: (minutes: number, seconds: number) => `[ 事故検出後 ${minutes} 分 ${seconds} 秒経過 ]`,
    farmMachineryUsageReport: '農機具使用レポート',
    accidentDetectionRelease: '事故検出解除',
    accidentDetectionReleaseReason: '検出解除の理由を選択してください',
    accidentDetectionReleaseReasonDesc: '検出された事故の状況を把握するため、\n正確な解除理由を選択してください。\n解除情報は[検出履歴]で確認できます。',
    accidentDetectionReleaseReasonDesc2: '検出された事故の状況を把握するため、',
    accidentDetectionReleaseReasonDesc3: '正確な解除理由を選択してください。\n解除情報は[検出履歴]で確認できます。',
    accidentDetectionReleaseButton: '検出解除',
    accidentOccurred: '発生事故',
    dangerousDriving: '危険運転',
    areaExit: '使用地域離脱',
    dangerousAreaEntry: '危険地域進入',
    batteryLow: 'バッテリー不足',
    engineAbandonment: 'エンジン放置',
    rolloverAccidentDetected: '転倒事故が検出されました。',
    checkUserSafetyImmediately: 'ユーザーの安全をすぐに確認してください！',
    // 농기계 사용 리포트 관련
    usageReportTitle: (name: string) => `${name}さんの農機具使用レポート`,
    closeReportConfirm: 'レポートを閉じますか？',
    deviceOperationStartDateMessage: 'デバイスの運転開始日が取得されました。',
    currentLocationError: '現在位置を取得できません。',
    addressLookupError: '住所検索エラー：',
    ownedDeviceList: '保有機器リスト',
    recentOperationHistory: '最近の運転履歴',
    operationEndLocation: '運転終了位置：',
    noRecentOperationHistory: '最近の運転履歴がありません。',
    viewMap: '地図を見る',
    viewOperationHistory: '運転履歴を見る',
    operationRunning: '運転中',
    operationEnd: '運転終了',
    // 소유자 정보 관련
    ownerInfo: '所有者情報',
    ownerLabel: '所有者',
    ownerContact: '所有者連絡先',
    currentLocation: '現在位置',
    contactViewConfirm: '連絡先を閲覧しますか？',
    contactViewContent: (item: string) => `デバイス${item}の個人情報保護のため、\n閲覧する担当者の正確な氏名を入力してください。`,
    contactViewButton: '連絡先閲覧',
    contactViewPlaceholder: '担当者の氏名を入力してください。',
    // 운행 관련
    lastOperationTime: '最終運転',
    noOperationRecord: '運転記録なし',
    // 차트 관련
    noDetectionInPeriod: '該期間内に検出履歴がありません。',
    pleaseReselectDate: '日付を再選択してください。',
    // 기기 정보 모달 관련
    rentalPurpose: 'レンタル目的',
    // 운행 기록 관련
    travelDistance: '移動距離',
    farmMachineryVoltage: '農機電圧',
    angle: '角度',
    addressUnavailable: '住所を確認できません。',
    operationLabel: '運行',
    degreeUnit: '度',
    currentStatus: '現在の状態',
    dailyInspectionRequiredMachineryList: '本日の点検要望農機具リスト',
    // 상태 관련
    statusNormal: '正常',
    statusCaution: '注意',
    statusDanger: '危険',
    vehicleRollover: '車両転覆',
    // 기기 정보 관련
    deviceType: '機器タイプ',
    // 감지 종류 (필터용)
    all: '全体',
    vehicleRolloverEvent: '車両転覆',
    dangerousDrivingEvent: '危険運転',
    engineAbandonmentEvent: 'エンジン放置',
    areaExitEvent: '使用地域離脱',
    batteryLowEvent: 'バッテリー不足',
    theftDetection: '盗難検知',
    dangerousAreaEntryEvent: '危険地域進入',
    // 기기 종류 (필터용)
    tractor: 'トラクター',
    speedSprayer: 'スピードスプレーヤー',
    fourWheelMotorcycle: '四輪オートバイ',
    twoWheelMotorcycle: '二輪オートバイ',
    oneTonTruck: '1トントラック',
    walkingManagement: '歩行管理機',
    ridingManagement: '乗用管理機',
    agriculturalHighWorkVehicle: '農業用高所作業車',
    agriculturalTransportVehicle: '農業用運搬車',
    agriculturalLoader: '農業用ローダー',
    ridingWeedCutter: '乗用草刈機',
    ridingWeedRemover: '乗用除草機',
    ridingTransplanter: '乗用田植機',
    fertilizerSpreader: '堆肥散布機',
    pesticideSpreader: '農薬散布機',
    combine: 'コンバイン',
    excavator: '掘削機',
    cultivator: '耕運機',
    branchCrusher: '残枝粉砕機',
    etc: 'その他',
  },
  
  history: {
    title: '検出履歴照会',
    detectionTime: '検出時刻',
    eventType: 'イベントタイプ',
    deviceName: 'デバイス名',
    owner: '所有者',
    dateRange: '期間',
    from: '開始日',
    to: '終了日',
    searchedDetections: '照会された検出履歴',
    detectionNumber: '検出番号',
    deviceType: 'デバイス種類',
    deviceName2: 'デバイス名',
    detectionDetails: '検出履歴',
    detectedDateTime: '検出日時',
    releasedDateTime: '解除日時',
    releaseReason: '解除理由',
    actionTakenBy: '措置者',
    detectionDetailView: '検出履歴詳細',
    noDataAvailable: '照会されたデータがありません。',
    noLocationData: '該当データの位置を確認できません。',
    downloadHistory: '検出履歴ダウン',
    selectDeviceType: 'デバイス種類選択',
    selectDetectionType: '検出種類選択',
    searchDeviceOwner: 'デバイス名、所有者名を検索',
    casesUnit: '件',
    lastOperation: '最終運行',
    distance: '移動距離',
    machineryVoltage: '農機電圧',
    currentStatus: '現在の状態',
    normal: '正常',
    detectionDetails2: '検出履歴',
    detectionDateTime: '検出日時',
    detectionLocation: '検出位置',
    releaseReason2: '解除理由',
    user2: 'ユーザー',
    userContact: 'ユーザー連絡先',
    guardian: '保護者',
    guardianContact: '保護者連絡先',
    guardianUserRelation: '保護者とユーザーの関係',
    operating: '運行',
    deviceTypeLabel: 'デバイス種類',
  },
  
  manageUser: {
    title: 'ユーザー管理',
    userList: 'ユーザーリスト',
    addUser: 'ユーザー追加',
    editUser: 'ユーザー編集',
    deleteUser: 'ユーザー削除',
    register: 'アカウント登録',
    permissionManagement: 'アカウント権限管理',
    cancelRegisterTitle: 'ユーザー登録をキャンセルしますか？',
    cancelRegisterContent: '確認をクリックすると入力内容がリセットされます。',
    userName: 'ユーザー名',
    phone: '電話番号',
    email: 'メール',
    area: 'グループ',
    grade: 'グレード',
    status: 'ステータス',
    searchUser: 'ユーザーIDまたは名前で検索',
    userAccountInfo: 'ユーザーアカウント情報',
    myAccountInfo: '自分のアカウント情報',
    confirmDelete: 'このアカウントを削除しますか？',
    deleteWarning: 'ユーザーはこれ以上このアカウントを使用できず、\n削除されたアカウント情報は復元できません。',
    accountName: 'アカウント名',
    userId: 'ID',
    contact: '連絡先',
    address: '住所',
    detailAddress: '詳細住所',
    accountCreationDate: 'アカウント作成日時',
    viewDetails: '詳細表示',
    viewContactRecord: '連絡先閲覧記録表示',
    recordsFound: '検索された記録',
    category: '区分',
    contactViewTime: '連絡先閲覧日時',
    reader: '閲覧者',
    deleteAccount: 'アカウント削除',
    resetPassword: 'パスワードリセット',
    noDataFound: 'データが見つかりません。',
    deleteMessage: '本当に削除しますか？',
    searchPlaceholder: '検索',
    peopleUnit: '名',
    // 追加キー
    passwordConfirm: 'パスワード確認',
    maxCharacters: '最大20文字',
    passwordRequirements: '特殊文字を含む8文字以上',
    emailExample: '例) test123@nongcall.com',
    phoneExample: '例) 010-1234-1234 / 031-123-1234',
    postcodeSearch: '郵便番号検索',
    clear: 'クリア',
    accountNamePlaceholder: '制御システムを使用する機関名を入力（最大20文字）',
    addressPlaceholder: '制御システムを使用する機関の住所を入力',
    userImageAlt: 'ユーザー画像',
    // 追加placeholderキー
    emailMaxCharacters: '最大50文字',
    phoneIncludeDash: 'ハイフンを含めて入力',
    detailAddressMaxCharacters: '最大100文字',
    // 権限管理セクション
    detectionNotification: '検知状況通知',
    functionManagement: '機能管理',
    dangerAccident: '危険（事故）',
    warningDangerousArea: '注意（危険地域進入）',
    batteryAbnormal: 'バッテリー異常',
    areaExit: '使用地域離脱',
    detectionRelease: '検知解除処理',
    deviceInfoModify: '機器情報修正',
    // パスワードリセット
    resetPasswordTitle: 'パスワードをリセットしますか？',
    resetPasswordContent: '確認をクリックするとパスワードがリセットされます。',
    // 連絡先閲覧モーダル
    openContact: '連絡先を閲覧しますか？',
    protectingPrivacy: 'ユーザーの個人情報を保護するため、\n閲覧する担当者の正確な氏名を入力してください。',
    openContactButton: '連絡先を閲覧',
    enterOfficerName: '担当者の氏名を入力してください。',
    // 連絡先表示
    noContact: '連絡先なし',
    viewContact: '連絡先表示',
    // マイページモーダル
    viewAccountInfo: 'アカウント情報を閲覧しますか？',
    enterPasswordForPrivacy: '個人情報保護のため\nアカウントパスワードを入力してください。',
    enterPasswordPlaceholder: 'パスワードを入力してください。',
    confirming: '確認中...',
  },
  
  manageNok: {
    title: '追加受信者管理',
    nokList: '追加受信者リスト',
    addNok: '追加受信者追加',
    editNok: '追加受信者編集',
    deleteNok: '追加受信者削除',
    nokName: '氏名',
    relationship: '関係',
    phone: '電話番号',
    priority: '優先順位',
    // 追加受信者管理ページ
    recipientInfo: '追加通知受信者情報',
    recipientContact: '追加受信者連絡先',
    ownerName: '所有者氏名',
    ownerContact: '所有者連絡先',
    accountCreationTime: 'アカウント作成日時',
    viewDetailInfo: '詳細情報表示',
    deleteAccount: 'アカウント削除',
    searchPlaceholder: '受信者IDまたは氏名で検索',
    registerRecipient: '追加受信者登録',
    sortByName: '氏名順',
    sortByContact: '受信者連絡先順',
    sortByOwnerName: '所有者氏名順',
    sortByOwnerContact: '所有者連絡先順',
    sortByRelationship: '関係順',
    sortByCreationTime: '作成日時順',
    defaultSort: 'デフォルト順',
    deleteConfirmTitle: 'このアカウントを削除しますか？',
    deleteConfirmContent: 'この受信者情報は使用できなくなり、\n削除された情報は復元できません。',
    noDataFound: 'データが見つかりません。',
    // 追加受信者登録/編集モーダル
    registerRecipientTitle: '追加受信者登録',
    registerRecipientSubtitle: '所有者選択',
    editRecipientTitle: '追加受信者編集',
    editRecipientSubtitle: '所有者選択',
    cancelRegisterTitle: '登録をキャンセルしますか？',
    cancelRegisterContent: '確認をクリックすると入力内容がリセットされます。',
    selectOwner: '所有者選択',
    nameLabel: '氏名',
    contactLabel: '連絡先',
    ownerLabel: '所有者',
    relationshipLabel: '関係',
    namePlaceholder: '受信者氏名',
    contactPlaceholder: '数字のみ（最小10桁）',
    relationshipPlaceholder: '関係を入力',
    contactMinLength: '連絡先は10桁以上入力してください。',
    contactOnlyNumbers: '連絡先は数字のみ入力可能です。',
    registerSuccess: '受信者登録成功',
    peopleUnit: '人',
    // 受信者詳細/編集モーダル
    detailInfoTitle: '受信者詳細情報',
    editInfoTitle: '受信者詳細情報編集',
    editSuccess: '受信者編集成功',
    cancelEditTitle: '受信者編集をキャンセルしますか？',
    cancelEditContent: '確認をクリックすると入力内容がリセットされます。',
    editComplete: '編集完了',
    maxCharacters: '最大20文字',
    includeDash: 'ハイフンを含めて入力してください。',
  },
  
  manageCustomer: {
    title: '顧客管理',
    customerList: '顧客リスト',
    addCustomer: '顧客追加',
    editCustomer: '顧客編集',
    deleteCustomer: '顧客削除',
    customerName: '顧客名',
    phone: '電話番号',
    memo: 'メモ',
    // 顧客管理ページ
    ownerInfo: '顧客情報',
    ownerNumber: '顧客番号',
    contact: '連絡先',
    name: '氏名',
    address: '住所',
    detailAddress: '詳細住所',
    group: 'グループ',
    viewDetailInfo: '詳細表示',
    deleteAccount: 'アカウント削除',
    searchPlaceholder: '顧客IDまたは氏名で検索',
    registerOwner: '顧客登録',
    sortByNumber: '顧客番号順',
    sortByContact: '連絡先順',
    sortByName: '氏名順',
    sortByAddress: '住所順',
    sortByDetailAddress: '詳細住所順',
    sortByGroup: 'グループ順',
    defaultSort: 'デフォルト順',
    deleteConfirmTitle: 'このアカウントを削除しますか？',
    deleteConfirmContent: '顧客はこのアカウントを使用できなくなり、\n削除されたアカウント情報は復元できません。',
    noDataFound: 'データが見つかりません。',
    peopleUnit: '人',
    casesUnit: '件',
    noAddress: '住所なし',
    noGroup: 'グループなし',
    noDetailAddress: '詳細住所なし',
    detailAddressLabel: '詳細住所',
    // 顧客詳細モーダル
    detailInfoTitle: '顧客詳細情報',
    editInfoTitle: '顧客編集',
    ownerName: '顧客名',
    ownerContact: '顧客連絡先(ID)',
    password: 'パスワード',
    joinDate: '登録日',
    other: 'その他',
    groupLabel: 'グループ',
    // 顧客編集モーダル
    modifyInfoTitle: '顧客詳細情報編集',
    modifyComplete: '編集完了',
    cancelModifyTitle: '顧客編集をキャンセルしますか？',
    cancelModifyContent: '確認を押すと入力した内容がリセットされます。',
    invalidPassword: '使用できないパスワードです。',
    passwordSpaceError: 'パスワードに空白は使用できません。',
    passwordRequirements: '英字、数字、特殊文字を最低1つずつ含み、\n合計8文字以上である必要があります。',
    maxCharacters20: '最大20文字',
    maxCharacters100: '最大100文字',
    includeDash: 'ハイフンを含めて入力してください。',
    addressPlaceholder: '住所',
    passwordPlaceholder: '英字、数字、特殊文字を含む8文字以上',
    groupSrLabel: '担当機関',
    // 연락처 관련
    noContact: '連絡先なし',
    viewContact: '連絡先表示',
    // 顧客登録モーダル
    registerInfoTitle: '顧客登録',
    registerComplete: '登録',
    cancelRegisterTitle: '顧客登録をキャンセルしますか？',
    cancelRegisterContent: '確認を押すと入力した内容がリセットされます。',
    registerSuccess: '顧客登録成功',
    numbersOnly: '数字のみ入力してください。',
    otherPlaceholder: 'その他入力',
    noDashNumbers: 'ハイフンなしの数字のみ',
  },
  
  manageMobility: {
    title: '農機管理',
    mobilityList: '農機リスト',
    addMobility: '農機追加',
    mobilityName: '農機名',
    mobilityType: '農機タイプ',
    owner: '所有者',
    status: 'ステータス',
  },
  
  mobileList: {
    title: '農機管理',
    searchDeviceOwner: 'デバイス名または所有者名で検索',
    from: '開始日',
    to: '終了日',
    selectDeviceType: 'デバイス種類選択',
    selectDetectionType: '検出種類選択',
    group: 'グループ',
    registerDevice: 'デバイス登録',
    searchedDevices: '照会されたデバイス',
    unit: '台',
    deviceName: 'デバイス名',
    deviceType: 'デバイス種類',
    owner: '所有者',
    operationStatus: '運行状態',
    lastOperationDate: '最終運行日時',
    terminalSN: '端末 S/N',
    machineryBattery: '農機 Bat',
    terminalBattery: '端末 Bat',
    testMode: '点検モード',
    deviceDetail: 'デバイス情報詳細',
    viewOnMap: '地図で見る',
    deviceDelete: 'デバイス削除',
    testModeActivate: 'モード状態を変更しますか？',
    testModeDeactivate: '点検モードを解除しますか？',
    testModeActivateContent: '点検モードに変更する場合、\n該当デバイスの事故通知を受けられず、\n点検モードが解除された後に再度受けられます。',
    testModeDeactivateContent: '点検モードを解除する場合、\n該当デバイスの事故通知が発生する場合があります。',
    deleteDevice: '該当デバイスを削除しますか？',
    deleteDeviceContent: 'デバイスを削除する場合、該当デバイスの情報を確認できず、\n削除されたデバイスの情報は再度復元できません。',
    confirmDelete: '削除',
    exportInstallHistory: '件インストール履歴エクスポート',
    exportCount: '件',
    noRecord: '走行記録なし',
    inspectionNeeded: '端末点検が必要です。',
    clipboardCopied: 'クリップボードにコピーされました。',
    noDownloadAvailable: 'ダウンロード可能なファイルがありません。',
    downloadSuccess: 'ファイルダウンロード成功',
  },
  
  deviceRegister: {
    title: 'デバイス登録',
    deviceName: 'デバイス名',
    deviceNamePlaceholder: '最大20文字',
    owner: '所有者',
    ownerPlaceholder: '所有者を選択してください',
    selectOwner: '所有者',
    deviceType: 'デバイス種類',
    terminalSerialNumber: '端末シリアル番号',
    terminalSerialPlaceholder: '基本8文字 ~ 最大16文字',
    terminalIMEI: '端末 IMEI',
    terminalIMEIPlaceholder: '数字15桁',
    numbersOnly: '数字のみ入力してください。',
    confirmRegister: '農機を登録しますか？',
    confirmRegisterContent: '登録した内容は後で修正可能です。',
    confirmRegisterButton: '登録',
    cancelRegister: 'デバイス登録をキャンセルしますか？',
    cancelRegisterContent: '確認を押すと入力した内容が初期化されます。',
    checkInput: '入力を再度確認してください。',
    registerCancel: 'キャンセル',
    registerButton: '登録',
    registerLoading: '登録',
    noRegisterButton: '登録',
    ownerRequired: '所有者を選択してください。',
    ownerError: '該当データは選択できません。',
    imageUploadSuccess: 'ユーザー画像の登録に成功しました',
    imageUploadError: 'イメージ登録中にエラーが発生しました。',
    bulkUploadTitle: 'デバイス情報Excelファイルをアップロードしてください。',
    bulkUploadContent: 'デバイス登録情報が記載されたExcelファイルをアップロードしてください。\n正確なデバイス登録のために、必ず様式に合わせて記載されたファイルのみ使用してください。',
  },
  
  deviceDetail: {
    title: 'デバイス情報詳細',
    titleEdit: 'デバイス情報修正',
    deviceName: 'デバイス名',
    owner: '所有者',
    ownerPlaceholder: '所有者を選択してください',
    ownerSelect: '所有者',
    registrationDate: 'デバイス登録日時',
    deviceType: 'デバイス種類',
    terminalSerialNumber: '端末シリアル番号',
    terminalIMEI: '端末 IMEI',
    modifyDevice: '修正',
    modifyComplete: '完了',
    cancelModify: 'デバイス情報修正をキャンセルしますか？',
    cancelModifyContent: '確認を押すと修正した内容が初期化されます。',
    ownerRequired: '所有者を選択してください。',
    ownerError: '該当データは選択できません。',
    numbersOnly: '数字のみ入力してください。',
    save: '保存',
    reset: 'キャンセル',
    installPhotos: 'インストール写真',
    overallView: '農機全体の様子',
    terminalInstallation: '端末インストールの様子',
    terminalSerialSticker: '端末シリアルステッカー',
    powerWiringStatus: '電源配線状態',
    machineryTypePlate: '農機型式表示板',
    userPhoto: 'ユーザー写真',
    noImage: '画像がありません。',
  },
  
  eventTypes: {
    accident: '転倒',
    battery: 'バッテリー不足',
    dangerous: '危険区域侵入',
    userArea: '使用区域外',
    emergency: '緊急通報',
    keyOn: '放置',
  },
  
  status: {
    normal: '正常',
    warning: '警告',
    error: 'エラー',
    running: '運行中',
    stopped: '停止',
    idle: '待機中',
  },
  
  navigation: {
    home: 'ホーム',
    accidentControl: '事故制御',
    detectionHistory: '検出履歴',
    statistics: '統計',
    notice: 'お知らせ',
    management: '管理',
    farmMachineryManagement: '農機管理',
    userAccountManagement: 'ユーザーアカウント管理',
    ownerManagement: '所有者管理',
    additionalRecipientManagement: '追加受信者管理',
    sitemap: 'サイトマップ',
    logout: 'ログアウト',
    honorific: '様',
  },
  
  notice: {
    title: 'お知らせ',
    goBack: 'リストに戻る',
    confirm: '確認',
    edit: '編集',
    editContent: '内容編集',
    delete: '削除',
    deleteTitle: 'お知らせを削除しますか？',
    deleteContent: '削除されたお知らせは所有者に表示されず、復元できません。',
    register: 'お知らせ登録',
    noNotice: '登録されたお知らせはありません。',
    previousNotice: '前のお知らせ',
    nextNotice: '次のお知らせ',
    new: '新規',
    web: 'WEB',
    app: 'APP',
    write: 'お知らせ作成',
    editTitle: 'お知らせ編集',
    category: 'お知らせ区分',
    noticeTitle: 'お知らせタイトル',
    titlePlaceholder: 'タイトルを入力してください（最大100文字）',
    cancel: 'キャンセル',
    complete: '完了',
    registerConfirm: 'お知らせを登録しますか？',
    registerContent: 'お知らせの内容は編集または削除でき、\n作成されたお知らせは所有者が確認できます。',
    cancelConfirm: 'リストに戻りますか？',
    cancelContent: '確認ボタンを押すと、\nこれまで作成した内容は保存されません。',
    editBreadcrumb: 'お知らせ編集',
    detailBreadcrumb: 'お知らせ詳細',
    contentPlaceholder: '本文内容を入力してください（最大2000文字）',
    imageFormatInfo: '* 添付可能な画像ファイル形式は png, jpg, jpeg です。',
    imageSizeInfo: '* 画像ファイル1個のサイズ制限は5MBで、最大5個まで添付可能です。',
    maxLengthExceeded: '2000文字を超過しました。',
    invalidFileFormat: 'ファイル形式を確認してください。\nアップロード可能なファイル形式は png, jpg, jpeg です。',
    maxImagesExceeded: '画像は最大5枚までしか添付できません。',
    maxSizeExceeded: '画像は最大5MBまでしか添付できません。',
    confirmTitle: '内容を確認してください。',
  },
  
  statistics: {
    title: '検出履歴統計',
    search: '照会',
    download: 'ダウンロード',
    invalidPeriod: '7日以上の期間で日付を再選択してください。',
    noData: '該当期間内の履歴がありません。\n日付を再選択してください。',
    monthView: '月別に見る',
    operatedMachinery: '運行した農機',
    totalMachinery: '全農機',
    dailyDetections: '日別検出履歴（件）',
    periodDetections: '期間内検出履歴（%）',
    hourlyDetections: '時間帯別検出履歴（件）',
    detectByType: '種類別検出履歴',
    detectList: '照会された検出履歴リスト',
    totalDetections: '総検出履歴',
    rolloverDetections: '転倒事故検出履歴',
    dangerousDrivingDetections: '危険運転検出履歴',
    outOfAreaDetections: '使用地域脱線検出履歴',
    batteryAnomalyDetections: 'バッテリー異常検出履歴',
    ignitionNeglectDetections: '始動放置検出履歴',
    cases: '件',
    units: '台',
    selectPeriod: '期間選択',
    selectPeriodPlaceholder: '-- 期間選択 --',
    oneMonth: '1か月',
    threeMonths: '3か月',
    sixMonths: '6か月',
    oneYear: '1年',
    timeUnit: '（単位：時間）',
    monthlyDetections: '月別検出履歴（件）',
    dailyView: '日別に見る',
    detectionHistory: '検出履歴',
    dayOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
    dangerousAreaEntryDetections: '危険区域進入検出履歴',
    user: 'ユーザー',
    lastOperation: '最後の運転',
    noDrivingRecord: '走行記録なし',
  },
};

